/****
 * Admin route guard that controls access to protected pages.
 * Checks whether the current user has Admin or Operator permissions
 * from the Redux store and redirects unauthorized users to the
 * "No Access" page while allowing authorized users to proceed.
 */
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { selectIsAdmin, selectIsOperator } from "@/store/userSlice";

const AdminGuard = ({ children }) => {
  const isAdmin = useSelector(selectIsAdmin);
  const isOperator = useSelector(selectIsOperator);

  if (!isAdmin && !isOperator) {
    return <Navigate to="/no-access" replace />;
  }

  return children;
};

export default AdminGuard;